import Ajax from '../util/ajax';
export function zigbeeAttributeReportingSet(nid, eid, cid, dir, aid, atype, min, max, change) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/' + cid + '/' + dir + '/reporting';
        ajax.post(url, [
            {
                op: 'set',
                attribute: aid,
                type: atype,
                min,
                max,
                change
            }
        ]);
    };
}
